// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import GoldLoanArrearReportTypes from './gold-loan-arrear-report.types';
import { goldLoanArrearReportFetch } from './gold-loan-arrear-report.service';
import { encryptData } from '../../_common/enode-decode';
import {
	fetchGoldLoanArrearReportFailure,
	fetchGoldLoanArrearReportResponseChanged,
	fetchGoldLoanArrearReportSuccess,
} from './gold-loan-arrear-report.action';

/** *********************  START GOLD LOAN ARREAR REPORT DETAILS  ******************** */
export function* fetchGoldLoanArrearReportDetails({ payload }: any) {
	try {
		const {
			companyID,
			reportDate,
			branchID,
			centerID,
			groupID,
			databaseName,
			funderID,
			limit,
		} = payload;
		const key = 'FetchGoldLoanArrearReportKey';
		const jsonData = {
			CompanyID: companyID,
			ReportDate: reportDate,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			DatabaseName: databaseName,
			FunderID: funderID,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(goldLoanArrearReportFetch, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchGoldLoanArrearReportFailure(responseData.data));
		} else {
			yield put(fetchGoldLoanArrearReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchGoldLoanArrearReportFailure(error));
	}
}

export function* resetFetchGoldLoanArrearReportResponse() {
	yield put(fetchGoldLoanArrearReportResponseChanged());
}

export function* onFetchGoldLoanArrearReportResponseDetails() {
	yield takeLatest(
		GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_START,
		fetchGoldLoanArrearReportDetails,
	);
}

export function* onFetchGoldLoanarrearReportResponseReset() {
	yield takeLatest(
		GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_RESET,
		resetFetchGoldLoanArrearReportResponse,
	);
}

/** *********************  END GOLD LOAN ARREAR REPORT DETAILS  ******************** */

export function* GoldLoanarrearPriceReportSaga() {
	yield all([
		call(onFetchGoldLoanArrearReportResponseDetails),
		call(onFetchGoldLoanarrearReportResponseReset),
	]);
}
